const StudentFieldEnum = {
  SAY: "SAY",
  SOZ: "SOZ",
  EA: "EA",
  DIL: "DIL",
  TYT: "TYT",
  "TYT+DIL": "TYT+DIL"
};

const FieldMetricEnum = {
  "YKS-SAY": "YKS-SAY",
  "YKS-SÖZ": "YKS-SÖZ",
  "YKS-EA": "YKS-EA",
  "YKS-DIL": "YKS-DIL",
  TYT: "TYT",
  LGS: "LGS"
};

const MetricFieldEnum = {
  "SAY-TYT": "SAY-TYT",
  "EA-TYT": "EA-TYT",
  "SOZ-TYT": "SOZ-TYT",
  "DIL-TYT": "DIL-TYT",
  "SAY-AYT": "SAY-AYT",
  "EA-AYT": "EA-AYT",
  "SOZ-AYT": "SOZ-AYT"
};

const MetricFielArray = Object.keys(MetricFieldEnum).map((key) => ({
  id: key,
  name: MetricFieldEnum[key]
}));

const StudentFieldArray = Object.keys(StudentFieldEnum).map((key) => ({
  id: key,
  name: StudentFieldEnum[key]
}));

const FieldMetricArray = Object.keys(FieldMetricEnum).map((key) => ({
  id: key,
  name: FieldMetricEnum[key]
}));

export { StudentFieldEnum, StudentFieldArray, FieldMetricEnum, FieldMetricArray, MetricFielArray };
